import { render, staticRenderFns } from "./SideBarHorizon.vue?vue&type=template&id=01117a7b"
import script from "./SideBarHorizon.vue?vue&type=script&lang=ts"
export * from "./SideBarHorizon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports